module.exports = __webpack_public_path__ + "static/media/podcast-database-icon.ef8ffe9a.svg";